import { render } from "./HeaderBanner.vue?vue&type=template&id=314fb1ee"
import script from "./HeaderBanner.vue?vue&type=script&lang=js"
export * from "./HeaderBanner.vue?vue&type=script&lang=js"

import exportComponent from "/home/mw/Code/hc-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__